import { Typography } from 'antd';
import { useStoreState } from '~/store';
import { Flex } from '~/components/Flex';

const PRIVACY_POLICY_URL = 'https://www.shipium.com/privacy';

/**
 * Marker in the localized body copy where the Privacy Policy link is spliced in. Translators can
 * move it to wherever the link belongs in their language.
 */
const PRIVACY_POLICY_TOKEN = '{privacyPolicy}';

const MAX_WIDTH = 760;

/**
 * Cookie and privacy consent notice shown in the login page footer to satisfy EU consent-notice
 * requirements. Informational only — no consent is recorded when the user logs in.
 */
export const PrivacyConsentBanner = () => {
  const i18n = useStoreState((state) => state.i18n.activeResources);

  // If a translation drops the marker, `afterLink` is undefined and the link is appended to the end
  // of the copy rather than silently disappearing — the Privacy Policy link always has to render.
  const [beforeLink, afterLink] = i18n['account.login.privacyBanner.body'].split(PRIVACY_POLICY_TOKEN);

  return (
    <Flex direction="vertical" gap="xs" maxWidth={MAX_WIDTH}>
      <Typography.Text strong>{i18n['account.login.privacyBanner.title']}</Typography.Text>
      <Typography.Text type="secondary">
        {beforeLink}
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
          {i18n['account.login.privacyBanner.privacyPolicy']}
        </a>
        {afterLink ?? ''}
      </Typography.Text>
    </Flex>
  );
};
